import {mapActions} from "vuex";
import rateSelect from "@/components/features/rate-select/index.vue";

export default {
    name: "GraduateWorkRate",
    props: {
        graduateWork: {
            required: true,
            type: Object
        },
        courseId: {
            required: true,
            type: Number
        }
    },
    components: {
        rateSelect,
    },
    computed: {
        hasCreatedRate() {
            return !Array.isArray(this.graduateWork.userRating.data)
        },
        value() {
            return this.hasCreatedRate ? this.graduateWork.userRating.data.rating : null;
        },
        summary() {
            return this.graduateWork.ratingSummary.data;
        }
    },
    methods: {
        ...mapActions({
            createRate: 'coursesGraduateWork/CREATE_RATE',
            updateRate: 'coursesGraduateWork/UPDATE_RATE'
        }),
        async onValueChanged(rating) {
            try {
                if (this.hasCreatedRate) {
                    await this.updateRate({
                        courseId: this.courseId,
                        rateId: this.graduateWork.userRating.data.id,
                        rating
                    })
                } else {
                    await this.createRate({
                        courseId: this.courseId,
                        rating
                    })
                }
                if (rating) {
                    this.$emit('showCommentForm', !!rating)
                }
            } catch (e) {
                console.error(e.message);
            }


        }
    }
};
